<template>
    <div class="course__edit_attachments">
        <template v-if="requestPending">
            <component-loading :size="'small'"></component-loading>
        </template>
        <template v-else>
            <component-system-uploader-pdf
                :is-course="isRouteCourse"
                :is-catalog-item="isRouteCatalogItem"
            ></component-system-uploader-pdf>
            <pop-notify
                ref="popnotifyvalidation"
                :class="'pop__notify--validation'"
                :title-text="`Something's not quite right`"
                :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
                :cancel-button-text="'OK'"
                :submit-button-active="false"
            />
        </template>
    </div>
</template>

<script>
import { validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import PopNotify from '@/components/default/shared/PopNotify'
import ComponentSystemUploaderPdf from '@/components/default/shared/ComponentSystemUploaderPDF'
import ComponentLoading from '@/components/default/shared/ComponentLoading'

export default {
  name: 'course-edit-attachments',
  components: {
    ComponentLoading,
    ComponentSystemUploaderPdf,
    PopNotify
  },
  data () {
    return {
      requestPending: false
    }
  },
  mixins: [validateBeforeRouteLeave, watchContentChangeEmit],
  computed: {
    loggedInUserWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    courseOwner () {
      return this.$store.getters.getEbsCourseOwner
    },
    customCourseLabels () {
      return this.courseLabelsNew.length ? this.courseLabelsNew.filter(fObj => fObj.constructor === String).map(mObj => {
        return {
          label: mObj,
          value: mObj
        }
      }) : []
    },
    //
    rootItemName () {
      return 'course'
    },
    //
    isAddMode () {
      return this.$route.name.includes('course-add')
    },
    isEditMode () {
      return this.$route.name.includes('course-edit')
    },
    isShowMode () {
      return this.$route.name.includes('course-show')
    },
    isRouteCourse () {
      return this.$route.name.includes('ebs-course-edit') || this.$route.name.includes('ebs-course-add')
    },
    isRouteCatalogItem () {
      return this.$route.name.includes('ebs-catalog-item-edit')
    },
    courseWorkspaceSettingsWorkspaces () {
      return this.$store.getters.getEbsCatalogItemWorkspacesSettings
    }
  },
  methods: {
    getCourseWorkspaceSettings () {
      this.requestPending = true
      const catalogId = this.$route.params.catalogId
      this.$store.dispatch('ebsCatalogItemGetWorkspaceSettings', catalogId).finally(() => {
        this.requestPending = false
        this.$eventBus.$emit('stop-loading')
      })
    }
  },
  inject: ['$validator'],
  created () {
    if (!this.courseWorkspaceSettingsWorkspaces.length && this.isRouteCatalogItem) {
      this.getCourseWorkspaceSettings()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseaddeditattachments";
</style>
